import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import StarIcon from '@material-ui/icons/StarBorder';
import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { showSnackbar } from '../../../../actions/appActions';
import withErrorCatcher from '../../../components/Common/withErrorCatcher';




// Apply some reset
const styles = theme => ({
    '@global': {
        ul: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
        },
    },
    appBar: {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    toolbar: {
        flexWrap: 'wrap',
    },
    toolbarTitle: {
        flexGrow: 1,
    },
    link: {
        margin: theme.spacing.unit * (1),
    },
    heroContent: {
        padding: theme.spacing.unit * (8),
    },
    cardHeader: {
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
    },
    cardPricing: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'baseline',
        marginBottom: theme.spacing.unit * (2),
    },
    footer: {
        borderTop: `1px solid ${theme.palette.divider}`,
        marginTop: theme.spacing.unit * (8),
        paddingTop: theme.spacing.unit * (3),
        paddingBottom: theme.spacing.unit * (3),
        [theme.breakpoints.up('sm')]: {
            paddingTop: theme.spacing.unit * (6),
            paddingBottom: theme.spacing.unit * (6),
        },
    },
});





class ChangeSubscriptionModal extends PureComponent {

    state = {
        usersNumber: 0,
        isSaving: false,
    }

    onChange = (event) => {
        this.setState({ usersNumber: event.target.value })
    }



    handleProductUpdateSave = () => {
        const { dispatch, billingService, onClose } = this.props;

        this.setState({ isSaving: true })
        billingService.updateSubscriptionType(2).then(() => {
            dispatch(showSnackbar('Saved!'));
            this.setState({ isSaving: false })
            onClose()
        })
        dispatch(showSnackbar('Saving...'));

    }

    componentDidMount() {
        this.setState({ usersNumber: this.props.usersNumber })
    }


    render() {
        const { open, onClose, classes, currentSubscription,t } = this.props;
        const { isSaving } = this.state;




        const tiers = [
            {
                title: 'First class',
                price: currentSubscription.billingInterval ? "290" : '29',
                description: [
                    'Everything from Business',
                    '1TB of storage',
                    'CRM',
                    'Customized Workflow',
                ],
                buttonText: 'Contact us',
                buttonVariant: 'outlined',
                buttonFunction: () => {
                    window.open("https://tuqqi.com/contact-sales", '_blank').focus()
                 }
            },
        ];

        // If Standard subscription
        if (currentSubscription === 1) {
            tiers.unshift({
                title: t('Business'),
                price: currentSubscription.billingInterval ? '190' : '19',
                description: [t('Users on demand'), t('Unlimited groups'), t('Unlimited custom inputs'), t('100GB of Storage')],
                buttonText: t('Update'),
                buttonVariant: 'outlined',
                buttonFunction: this.handleProductUpdateSave,
                subscriptionType: 2,
            });
        }



        return (
            <Dialog

                // onEnter={this.initText}
                open={open}
                onRequestClose={onClose}>
                <DialogTitle>{t('Upgrade plan')}</DialogTitle>
                <DialogContent>
                    <div data-intrcm-id="ChangeSubscriptionModal_88bw84a1" style={{ width: 800 }}>
                        <Grid container justify="center" spacing={8} >
                            {tiers.map((tier) => (
                                <Grid item key={tier.title} xs={6} spacing={8}>
                                    <Card>
                                        <CardHeader
                                            title={tier.title}
                                            subheader={tier.subheader}
                                            titleTypographyProps={{ align: 'center' }}
                                            subheaderTypographyProps={{ align: 'center' }}
                                            action={tier.title === 'Pro' ? <StarIcon /> : null}
                                            className={classes.cardHeader}
                                        />
                                        <CardContent>
                                            {/* <div data-intrcm-id="ChangeSubscriptionModal_6ht9fl8y" className={classes.cardPricing}>
                                                <Typography component="h2" variant="h3" color="textPrimary">
                                                    ${tier.price}
                                                </Typography>
                                                <Typography variant="h6" color="textSecondary">
                                                    {currentSubscription.billingInterval ? '/year' : '/mo'}
                                                </Typography>
                                            </div> */}
                                            <ul>
                                                {tier.description.map((line) => (
                                                    <Typography component="li" variant="subtitle1" align="center" key={line}>
                                                        {line}
                                                    </Typography>
                                                ))}
                                            </ul>
                                        </CardContent>
                                        <CardActions>
                                            <Button fullWidth variant={tier.buttonVariant} onClick={tier.buttonFunction} color="primary">
                                                {tier.buttonText}
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="primary">
                        {t('Close')}
           </Button>

                </DialogActions>
            </Dialog>)
    }




}


const mapStateToProps = (state) => ({
    userData: state.userData,
    userProfile: state.userData,
    tagInfo: state.results.channel,
    globalData: state.globalData,
    ...state.services
})

const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles),
    withTranslation('admin'),
    withErrorCatcher(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(ChangeSubscriptionModal);

